import $ from "jquery";
import { smoothscroll } from "../utils/smoothscroll";

const $boardListEl = $(".board-list");

$(function () {
  if ($boardListEl.length > 0) {
    $boardListEl.each(function () {
      boardList($(this));
    });
  }
});

const boardList = (listEl) => {
  const filter = {
    page: 1,
    limit: listEl.data("limit"),
    categories: listEl.data("categories"),
    tags: listEl.data("tags"),
    category: -1,
    tag: -1,
    year: -1,
    lang: $boardListEl.data("lang"),
  };

  bindPosts(listEl, filter);
  bindPostFilter(listEl, filter);
};

const reRenderList = async (element, filter, scrollTop = false) => {
  const data = await getPosts(filter);
  element.find(".board-list__content").html(data.html);

  if (scrollTop === true) {
    smoothscroll(element);
  }
};

const bindPosts = (element, filter) => {
  element.on("click", ".pagination__item", function () {
    const $thisEl = $(this);
    filter.page = $thisEl.data("page");
    reRenderList(element, filter, true);
  });
};

const bindPostFilter = (element, filter) => {
  element.on("change", "select[name='select-board-years']", function () {
    const $thisEl = $(this);
    filter.page = 1;
    filter.year = $thisEl.val();
    filter.category = element
      .find("select[name='select-board-categories']")
      .val();
    filter.tag = element.find("select[name='select-board-tags']").val();
    reRenderList(element, filter);
  });

  element.on("change", "select[name='select-board-categories']", function () {
    const $thisEl = $(this);
    filter.page = 1;
    filter.category = $thisEl.val();
    filter.tag = element.find("select[name='select-board-tags']").val();
    filter.year = element.find("select[name='select-board-years']").val();
    reRenderList(element, filter);
  });

  element.on("change", "select[name='select-board-tags']", function () {
    const $thisEl = $(this);
    filter.page = 1;
    filter.tag = $thisEl.val();
    filter.category = element
      .find("select[name='select-board-categories']")
      .val();
    filter.year = element.find("select[name='select-board-years']").val();
    reRenderList(element, filter);
  });

  element.on("click", "button[name='remove-board-filter']", function () {
    const $thisEl = $(this);
    filter.page = 1;
    filter.year = -1;
    filter.category = -1;
    filter.tag = -1;

    $thisEl
      .closest(".block-filter")
      .find("select[name='select-board-categories']")
      .val("-1");
    $thisEl
      .closest(".block-filter")
      .find("select[name='select-board-tags']")
      .val("-1");
    $thisEl
      .closest(".block-filter")
      .find("select[name='select-board-years']")
      .val("-1");

    reRenderList(element, filter);
  });
};

const getPosts = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + "/wp-json/malacky/v1/board-list/html",
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(filter),
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};
